import { PromoAnalyticsService } from '@analytics/feature';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { BannerDefaultItem } from '@promo/const';
import { PromoService } from '@promo/data-access';
import { SdvorGenericLinkComponent } from '@sdvor/shared/ui';
import { DeviceService } from '@shared/services';
import { combineLatest, filter, map, Observable } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sd-banner',
  templateUrl: 'banner.component.html',
  styleUrls: ['banner.component.scss'],
  imports: [AsyncPipe, SdvorGenericLinkComponent, NgOptimizedImage],
})
export class BannerComponent implements OnInit {
  private readonly promoService = inject(PromoService);
  private readonly deviceService = inject(DeviceService);
  private readonly promoAnalyticsService = inject(PromoAnalyticsService);

  isTabletUp$: Observable<boolean> = this.deviceService.isTabletMdUp$;
  isDesktopUp$: Observable<boolean> = this.deviceService.isDesktopLgUp$;
  isLoading$: Observable<boolean> = this.promoService.getPromoLoading();

  banner$: Observable<BannerDefaultItem | undefined>;

  ngOnInit(): void {
    this.banner$ = combineLatest({
      promo: this.promoService.getPromo().pipe(filter((promo) => !!promo)),
      isTabletUp: this.isTabletUp$,
      isDesktopUp: this.isDesktopUp$,
    }).pipe(
      map(({ promo, isTabletUp, isDesktopUp }) => {
        if (!promo.banner) {
          return undefined;
        }

        const { url } = promo.banner;

        return {
          ...promo.banner,
          url: isDesktopUp ? url.isDesktop : isTabletUp ? url.isTablet : url.isMobile,
        };
      }),
    );
  }

  protected onBannerClick(banner: BannerDefaultItem): void {
    const { id, name } = banner;

    this.promoAnalyticsService.onClickBanner({
      id,
      name,
      position: 'points',
    });
  }
}
